import ReactDOM from 'react-dom';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Provider } from 'react-redux';
import './utils/debug';
import App from './chunks/App';
import store from './store';
import './utils/fonts';
import { GlobalStyle } from './theme/global';
import polyfills from './utils/polyfills';
import checkStorageAccess from './utils/storageAccessAPI';
import './utils/touchable';
import { parseGetParams } from './utils/routerUrl';
import appActions from './actions/app';

polyfills(mount);

const searchQuery = parseGetParams(self.location.search);
const loginCookie = Cookies.get('embed_user_logined');

function mount() {
  const storageAccessCallback = (hasAccess) => store.dispatch(appActions.setStorageAccess(hasAccess));
  checkStorageAccess(storageAccessCallback)
    .catch((exception) => {
      self.debug('entry')('Exception on request storage access', exception.message);
      store.dispatch(appActions.setStorageAccess(false));
    })
    .then((hasAccess) => store.dispatch(appActions.setStorageAccess(hasAccess)))
    .then(() => {
      ReactDOM.render(
        <Provider store={store}>
          <>
            <GlobalStyle />
            <Router basename={process.env.BASE_URL}>
              <App searchQuery={searchQuery} isLoggedIn={loginCookie} />
            </Router>
          </>
        </Provider>,
        document.getElementById('root')
      );
      console.log('Build date: %s', new Date(process.env.BUILD_DATE));
    });
}
